import FormrenderMount from "./FormrenderMount"
import { RootRouteContentType } from "@fusion-advantage/formlib"
import { useAppSelector } from "./redux/hooks"
import { LxDashboard } from "./stories/content/dashboard/LxDashboard"

export const ContentRouterElement = () => {
	const content = useAppSelector(state => state.app.content)
	switch(content.type) {
		case RootRouteContentType.Dashboard:
			return <LxDashboard />
		case RootRouteContentType.Form:
			const instanceId = content.renderInstanceId
			// setting a key here from state ensures the component gets
			// tossed out & recreated whenever new ceontent is set
			// by setAppContent()
			// https://react.dev/learn/preserving-and-resetting-state#option-2-resetting-state-with-a-key
			return <FormrenderMount key={instanceId} />
		default:
			return null
	}
}
